import { useContext } from 'react';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { ThemeContext } from '@forma/forma-ui-kit';
import MainBanner3 from '@/components/blocks/MainBanner3';
// import VideoBanner2 from '@/components/blocks/VideoBanner2';
import PartnershipTable from '@/components/blocks/PartnershipTable';
import PartnershipInfo from '@/components/blocks/PartnershipInfo';
import PartnershipHowTo from '@/components/blocks/PartnershipHowTo';
import Faq from '@/components/blocksMiniBuisness/Faq';
import MetaTags from '@/components/MetaTags';
import useMetaTags from '@/hooks/useMetaTags';
import { queries } from '@/helpers/api';
import getHeadersFromServer from '@/helpers/getHeadersFromServer';
import RegisterBanner from '@/components/blocks/RegisterBanner';

export const getServerSideProps = async ({ req, res, params }) => {
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=14400, stale-while-revalidate=10'
  );
  const mainData = await queries.getMainData(params.locale);
  const pageData = await queries.getPromoData(params.locale, 'partnership');
  const headersParse = await getHeadersFromServer(req);
  return {
    props: {
      initialState: {
        main: mainData,
      },
      pageData,
      headersParse,
      ...(await serverSideTranslations(params.locale, ['common', 'uikit'])),
    },
  };
};

const Page = ({ pageData }) => {
  const { t } = useTranslation();
  const {
    main_banner, video_banner, faq, how_to, tariffs, info, request_register, call_modal
  } = pageData;
  const metaData = {
    title: t('meta_titles.solutions', { name: main_banner.label }),
    description: t('meta_descriptions.solutions', { name: main_banner.label, subtitle: main_banner.subtitle }),
    keywords: t('main_keywords'),
  };
  const { lang } = useContext(ThemeContext);
  useMetaTags({ lang, ...metaData });

  return (
    <div>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
      </Head>

      <MainBanner3 {...main_banner} callModal={call_modal} />
      <PartnershipTable {...tariffs} />
      {/* <VideoBanner2 {...video_banner} callModal={call_modal} /> */}
      <PartnershipInfo {...info} callModal={call_modal} />
      <PartnershipHowTo {...how_to} />
      <Faq {...faq} />
      <RegisterBanner {...request_register} callModal={call_modal} />
    </div>
  );
};

export default Page;
